export default __webpack_public_path__ + "static/media/StocksGroupImage.4bcbb7e9.svg";